import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

// Menu configuration
const GROUPED_MENU_ITEMS = {
  school_admin: [
    {
      group: 'main',
      label: 'Main',
      labelHi: 'मुख्य',
      items: [
        { id: 'dashboard', label: 'Dashboard', labelHi: 'डैशबोर्ड', icon: '📊' },
        { id: 'school-profile', label: 'School Profile', labelHi: 'स्कूल प्रोफ़ाइल', icon: '🏫' },
        { id: 'onboarding-schedule', label: 'Onboarding & Data', labelHi: 'Onboarding & डेटा', icon: '🚀' },
        { id: 'billing', label: 'Billing', labelHi: 'बिलिंग', icon: '💳' },
        { id: 'setup-guide', label: 'Setup Guide', labelHi: 'सेटअप गाइड', icon: '🎯' },
        { id: 'admission-engine', label: 'Admission Engine', labelHi: 'Admission Engine', icon: '🚀' },
      ]
    },
    {
      group: 'academic',
      label: 'Academic',
      labelHi: 'शैक्षणिक',
      items: [
        { id: 'classes', label: 'Classes', labelHi: 'कक्षाएं', icon: '📚' },
        { id: 'students', label: 'Students', labelHi: 'छात्र', icon: '👨‍🎓' },
        { id: 'teachers', label: 'Teachers', labelHi: 'शिक्षक', icon: '👨‍🏫' },
        { id: 'attendance', label: 'Attendance', labelHi: 'उपस्थिति', icon: '✅' },
        { id: 'exams', label: 'Exams & Results', labelHi: 'परीक्षा', icon: '📝' },
        { id: 'timetable', label: 'Timetable', labelHi: 'समय सारणी', icon: '🗓️' },
        { id: 'calendar', label: 'Calendar', labelHi: 'कैलेंडर', icon: '📅' },
      ]
    },
    {
      group: 'finance',
      label: 'Finance',
      labelHi: 'वित्त',
      items: [
        { id: 'fees', label: 'Fees', labelHi: 'फीस', icon: '💰' },
        { id: 'fee-structure', label: 'Fee Structure', labelHi: 'शुल्क संरचना', icon: '📋' },
        { id: 'wallet', label: 'Wallet', labelHi: 'वॉलेट', icon: '💳' },
        { id: 'padhai-emi', label: 'Padhai EMI', labelHi: 'पढ़ाई EMI', icon: '🏦' },
      ]
    },
    {
      group: 'operations',
      label: 'Operations',
      labelHi: 'संचालन',
      items: [
        { id: 'transport', label: 'Transport', labelHi: 'परिवहन', icon: '🚌' },
        { id: 'hr-payroll', label: 'HR & Payroll', labelHi: 'HR और पेरोल', icon: '👨‍💼' },
        { id: 'library', label: 'Library', labelHi: 'पुस्तकालय', icon: '📖' },
        { id: 'leave-management', label: 'Leave', labelHi: 'छुट्टी', icon: '📋' },
        { id: 'emergency-exit', label: 'Emergency', labelHi: 'आपातकाल', icon: '🚨' },
      ]
    },
    {
      group: 'marketing',
      label: 'Marketing & Leads',
      labelHi: 'मार्केटिंग और लीड्स',
      items: [
        { id: 'lead-crm', label: 'Lead CRM', labelHi: 'लीड CRM', icon: '🎯' },
        { id: 'lead-nurturing', label: 'Lead Nurturing', labelHi: 'लीड Nurturing', icon: '🌱' },
        { id: 'follow-ups', label: 'Follow-ups', labelHi: 'फॉलो-अप', icon: '⏰' },
        { id: 'campaign-manager', label: 'Campaign Manager', labelHi: 'कैम्पेन मैनेजर', icon: '📢' },
        { id: 'school-analytics', label: 'Analytics', labelHi: 'एनालिटिक्स', icon: '📈' },
      ]
    },
    {
      group: 'communication',
      label: 'Communication',
      labelHi: 'संचार',
      items: [
        { id: 'communication', label: 'Announcements', labelHi: 'घोषणाएं', icon: '📢' },
        { id: 'complaints', label: 'Complaints', labelHi: 'शिकायतें', icon: '📝' },
        { id: 'notifications', label: 'Notifications', labelHi: 'सूचनाएं', icon: '🔔' },
        { id: 'social-media', label: 'Social Media', labelHi: 'सोशल मीडिया', icon: '📱' },
        { id: 'newsletter', label: 'Newsletter', labelHi: 'न्यूज़लेटर', icon: '📰' },
      ]
    },
    {
      group: 'data',
      label: 'Data & Reports',
      labelHi: 'डेटा व रिपोर्ट',
      items: [
        { id: 'bulk', label: 'Bulk Import', labelHi: 'बल्क इम्पोर्ट', icon: '📥' },
        { id: 'data-export', label: 'Data Export', labelHi: 'डेटा एक्सपोर्ट', icon: '📤' },
        { id: 'data-tasks', label: 'Data Tasks', labelHi: 'डेटा टास्क', icon: '📋' },
        { id: 'reports', label: 'Reports', labelHi: 'रिपोर्ट', icon: '📄' },
        { id: 'audit-logs', label: 'Audit Logs', labelHi: 'ऑडिट लॉग', icon: '🕐' },
        { id: 'documents', label: 'Documents', labelHi: 'दस्तावेज़', icon: '📁' },
        { id: 'udise', label: 'UDISE+', labelHi: 'UDISE+', icon: '🏛️' },
      ]
    },
    {
      group: 'ai',
      label: 'AI & Tools',
      labelHi: 'AI व टूल्स',
      items: [
        { id: 'ai', label: 'AI Features', labelHi: 'AI सुविधाएं', icon: '🤖' },
        { id: 'ai-usage', label: 'AI Usage', labelHi: 'AI उपयोग', icon: '📈' },
        { id: 'doubt-history', label: 'Doubt History', labelHi: 'डाउट हिस्ट्री', icon: '❓' },
      ]
    },
    {
      group: 'settings',
      label: 'Settings',
      labelHi: 'सेटिंग्स',
      items: [
        { id: 'settings', label: 'Settings', labelHi: 'सेटिंग्स', icon: '⚙️' },
        { id: 'scheduler', label: 'Scheduler', labelHi: 'शेड्यूलर', icon: '⏰' },
        { id: 'domain-settings', label: 'Custom Domain', labelHi: 'कस्टम डोमेन', icon: '🌐' },
      ]
    },
  ],
  teacher: [
    {
      group: 'main',
      label: 'Main',
      labelHi: 'मुख्य',
      items: [
        { id: 'dashboard', label: 'Dashboard', labelHi: 'डैशबोर्ड', icon: '📊' },
      ]
    },
    {
      group: 'academic',
      label: 'My Classes',
      labelHi: 'मेरी कक्षाएं',
      items: [
        { id: 'students', label: 'Students', labelHi: 'छात्र', icon: '👨‍🎓' },
        { id: 'attendance', label: 'Attendance', labelHi: 'उपस्थिति', icon: '✅' },
        { id: 'exams', label: 'Exams & Results', labelHi: 'परीक्षा व रिज़ल्ट', icon: '📝' },
        { id: 'timetable', label: 'Timetable', labelHi: 'समय सारणी', icon: '🗓️' },
        { id: 'calendar', label: 'Calendar', labelHi: 'कैलेंडर', icon: '📅' },
      ]
    },
    {
      group: 'tools',
      label: 'Tools',
      labelHi: 'टूल्स',
      items: [
        { id: 'leave-requests', label: 'My Leave', labelHi: 'मेरी छुट्टी', icon: '📋' },
        { id: 'library', label: 'Library', labelHi: 'पुस्तकालय', icon: '📖' },
        { id: 'communication', label: 'Announcements', labelHi: 'घोषणाएं', icon: '📢' },
        { id: 'ai', label: 'AI Features', labelHi: 'AI सुविधाएं', icon: '🤖' },
        { id: 'doubt-history', label: 'Doubt History', labelHi: 'डाउट हिस्ट्री', icon: '❓' },
      ]
    },
  ],
  student: [
    {
      group: 'main',
      label: 'Main',
      labelHi: 'मुख्य',
      items: [
        { id: 'portal-dashboard', label: 'Dashboard', labelHi: 'डैशबोर्ड', icon: '📊' },
      ]
    },
    {
      group: 'academic',
      label: 'My Studies',
      labelHi: 'मेरी पढ़ाई',
      items: [
        { id: 'portal-attendance', label: 'Attendance', labelHi: 'उपस्थिति', icon: '✅' },
        { id: 'portal-fees', label: 'Fees', labelHi: 'फीस', icon: '💰' },
        { id: 'portal-announcements', label: 'Announcements', labelHi: 'घोषणाएं', icon: '📢' },
      ]
    },
    {
      group: 'tools',
      label: 'Tools',
      labelHi: 'टूल्स',
      items: [
        { id: 'ai', label: 'AI Features', labelHi: 'AI सुविधाएं', icon: '🤖' },
        { id: 'doubt-history', label: 'Doubt History', labelHi: 'डाउट हिस्ट्री', icon: '❓' },
        { id: 'portal-bus-tracking', label: 'Bus Tracking', labelHi: 'बस ट्रैकिंग', icon: '🚌' },
      ]
    },
  ],
};

const FLAT_MENU_ITEMS = {
  platform_admin: [
    { id: 'dashboard', label: 'Dashboard', labelHi: 'डैशबोर्ड', icon: '📊' },
    { id: 'schools', label: 'Schools', labelHi: 'स्कूल', icon: '🏫' },
    { id: 'admission-engine', label: 'Admission Engine', labelHi: 'Admission Engine', icon: '🚀' },
    { id: 'padhai-emi', label: 'Padhai EMI', labelHi: 'पढ़ाई EMI', icon: '🏦' },
    { id: 'nbfc-approval', label: 'NBFC Approval', labelHi: 'NBFC अप्रूवल', icon: '✅' },
    { id: 'campaign-manager', label: 'Campaign Manager', labelHi: 'कैम्पेन मैनेजर', icon: '📢', tag: 'New' },
    { id: 'aayush-rulebook', label: 'Aayush Rulebook', labelHi: 'आयुष रूलबुक', icon: '📘', tag: 'New' },
    { id: 'aayush-knowledge', label: 'Aayush Knowledge Base', labelHi: 'आयुष नॉलेज बेस', icon: '🧠', tag: 'New' },
    { id: 'school-finder', label: 'School Finder', labelHi: 'स्कूल फाइंडर', icon: '🔍' },
    { id: 'analytics', label: 'Analytics', labelHi: 'एनालिटिक्स', icon: '📈' },
    { id: 'follow-ups', label: 'Follow-ups', labelHi: 'फॉलो-अप', icon: '⏰' },
    { id: 'lead-crm', label: 'Lead CRM', labelHi: 'लीड CRM', icon: '🎯' },
    { id: 'feature-editor', label: 'Feature Editor', labelHi: 'फीचर एडिटर', icon: '🎨' },
    { id: 'data-tasks', label: 'Data Tasks', labelHi: 'डेटा टास्क', icon: '📋' },
    { id: 'data-export', label: 'Data Export', labelHi: 'डेटा एक्सपोर्ट', icon: '📤' },
    { id: 'lead-nurturing', label: 'Lead Nurturing', labelHi: 'लीड Nurturing', icon: '🌱' },
    { id: 'ai', label: 'AI Features', labelHi: 'AI सुविधाएं', icon: '🤖' },
    { id: 'social-media', label: 'Social Media', labelHi: 'सोशल मीडिया', icon: '📱' },
    { id: 'whatsapp', label: 'WhatsApp', labelHi: 'WhatsApp', icon: '💬' },
    { id: 'newsletter', label: 'Newsletter', labelHi: 'न्यूज़लेटर', icon: '📰' },
    { id: 'notifications', label: 'Notifications', labelHi: 'सूचनाएं', icon: '🔔' },
    { id: 'audit-logs', label: 'Audit Logs', labelHi: 'ऑडिट लॉग', icon: '🕐' },
    { id: 'documents', label: 'Documents', labelHi: 'दस्तावेज़', icon: '📁' },
    { id: 'doubt-history', label: 'Doubt History', labelHi: 'डाउट हिस्ट्री', icon: '❓' },
    { id: 'scheduler', label: 'Scheduler', labelHi: 'शेड्यूलर', icon: '⏰' },
    { id: 'settings', label: 'Settings', labelHi: 'सेटिंग्स', icon: '⚙️' },
  ],
  teacher: [
    { id: 'dashboard', label: 'Dashboard', labelHi: 'डैशबोर्ड', icon: '🏠' },
    { id: 'students', label: 'Students', labelHi: 'छात्र', icon: '👨‍🎓' },
    { id: 'attendance', label: 'Attendance', labelHi: 'उपस्थिति', icon: '✅' },
    { id: 'exams', label: 'Exams', labelHi: 'परीक्षा', icon: '📝' },
    { id: 'timetable', label: 'Timetable', labelHi: 'समय सारणी', icon: '📅' },
    { id: 'data-tasks', label: 'Data Tasks', labelHi: 'डेटा टास्क', icon: '📝' },
    { id: 'leave-requests', label: 'Leave Requests', labelHi: 'छुट्टी अनुरोध', icon: '📋' },
    { id: 'ai', label: 'AI Features', labelHi: 'AI सुविधाएं', icon: '🤖' },
  ],
  parent: [
    { id: 'portal-dashboard', label: 'Dashboard', labelHi: 'डैशबोर्ड', icon: '🏠' },
    { id: 'parent-dashboard', label: 'Child Report', labelHi: 'बच्चे की रिपोर्ट', icon: '👶' },
    { id: 'portal-attendance', label: 'Attendance', labelHi: 'उपस्थिति', icon: '✅' },
    { id: 'portal-fees', label: 'Fees', labelHi: 'फीस', icon: '💰' },
    { id: 'leave-apply', label: 'Leave Apply', labelHi: 'छुट्टी आवेदन', icon: '📝' },
    { id: 'data-tasks', label: 'Data Tasks', labelHi: 'डेटा टास्क', icon: '📝' },
    { id: 'portal-announcements', label: 'Announcements', labelHi: 'घोषणाएं', icon: '📢' },
    { id: 'portal-complaints', label: 'Complaints', labelHi: 'शिकायतें', icon: '📝' },
    { id: 'ai', label: 'AI Features', labelHi: 'AI सुविधाएं', icon: '🤖' },
  ],
  student: [
    { id: 'portal-dashboard', label: 'Dashboard', labelHi: 'डैशबोर्ड', icon: '🏠' },
    { id: 'portal-attendance', label: 'Attendance', labelHi: 'उपस्थिति', icon: '✅' },
    { id: 'portal-fees', label: 'Fees', labelHi: 'फीस', icon: '💰' },
    { id: 'portal-announcements', label: 'Announcements', labelHi: 'घोषणाएं', icon: '📢' },
    { id: 'ai', label: 'AI Features', labelHi: 'AI सुविधाएं', icon: '🤖' },
  ],
};

/**
 * Sidebar Component - Navigation sidebar with role-based menus
 */
export function Sidebar({ role, activeTab, setActiveTab, isMobile = false, onClose }) {
  const [expandedGroups, setExpandedGroups] = useState(['main']);
  const { language } = useLanguage();

  const toggleGroup = (groupId) => {
    setExpandedGroups(prev => 
      prev.includes(groupId) 
        ? prev.filter(g => g !== groupId)
        : [...prev, groupId]
    );
  };

  const isGroupActive = (items) => items.some(item => item.id === activeTab);

  // Product tour: expand every group so all nav items render for highlighting.
  useEffect(() => {
    const h = () => {
      const cfg = GROUPED_MENU_ITEMS[role];
      if (cfg) setExpandedGroups(cfg.map(g => g.group));
    };
    window.addEventListener('school-tour:expand-nav', h);
    return () => window.removeEventListener('school-tour:expand-nav', h);
  }, [role]);

  const handleItemClick = (itemId) => {
    setActiveTab(itemId);
    if (isMobile && onClose) onClose();
  };

  // Render grouped menu for school_admin, teacher, student
  const groupedConfig = GROUPED_MENU_ITEMS[role];
  if (groupedConfig) {
    return (
      <aside 
        className={`${isMobile ? 'fixed inset-y-0 left-0 z-50 transform transition-transform duration-300' : ''} w-64 bg-white shadow-lg min-h-screen overflow-y-auto`}
        data-testid="sidebar"
      >
        {isMobile && (
          <div className="flex justify-end p-2">
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700 text-2xl">&times;</button>
          </div>
        )}
        <nav className="p-3 space-y-1">
          {groupedConfig.map(group => (
            <div key={group.group} className="mb-1">
              <button
                onClick={() => toggleGroup(group.group)}
                className={`w-full flex items-center justify-between px-3 py-2 rounded-lg text-sm font-medium transition ${
                  isGroupActive(group.items) 
                    ? 'bg-orange-50 text-orange-700' 
                    : 'text-gray-500 hover:bg-gray-50'
                }`}
              >
                <span>{language === 'hi' ? group.labelHi : group.label}</span>
                <span className={`transform transition-transform ${expandedGroups.includes(group.group) ? 'rotate-180' : ''}`}>
                  ▼
                </span>
              </button>
              
              {expandedGroups.includes(group.group) && (
                <div className="ml-2 mt-1 space-y-0.5 border-l-2 border-orange-100 pl-2">
                  {group.items.map(item => (
                    <button
                      key={item.id}
                      onClick={() => handleItemClick(item.id)}
                      className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm transition ${
                        activeTab === item.id 
                          ? 'bg-orange-100 text-orange-700 font-medium' 
                          : 'text-gray-600 hover:bg-gray-50'
                      }`}
                      data-testid={`nav-${item.id}`}
                    >
                      <span className="text-base">{item.icon}</span>
                      <span>{language === 'hi' ? item.labelHi : item.label}</span>
                      {item.tag && (
                        <span className="ml-auto text-xs px-1.5 py-0.5 bg-yellow-100 text-yellow-700 rounded-full">
                          {item.tag}
                        </span>
                      )}
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>
      </aside>
    );
  }

  // Flat menu for other roles
  const items = FLAT_MENU_ITEMS[role] || FLAT_MENU_ITEMS.platform_admin;

  return (
    <aside 
      className={`${isMobile ? 'fixed inset-y-0 left-0 z-50 transform transition-transform duration-300' : ''} w-64 bg-white shadow-lg min-h-screen`}
      data-testid="sidebar"
    >
      {isMobile && (
        <div className="flex justify-end p-2">
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 text-2xl">&times;</button>
        </div>
      )}
      <nav className="p-4 space-y-2">
        {items.map(item => (
          <button 
            key={item.id} 
            onClick={() => handleItemClick(item.id)}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition ${
              activeTab === item.id ? 'bg-orange-100 text-orange-700 font-medium' : 'text-gray-600 hover:bg-gray-100'
            }`} 
            data-testid={`nav-${item.id}`}
          >
            <span className="text-xl">{item.icon}</span>
            <span>{language === 'hi' ? (item.labelHi || item.label) : item.label}</span>
            {item.tag && (
              <span className="ml-auto text-xs px-2 py-0.5 bg-yellow-100 text-yellow-700 rounded-full">
                {item.tag}
              </span>
            )}
          </button>
        ))}
      </nav>
    </aside>
  );
}

export default Sidebar;
